/** Whether DialogWrapper should re-apply preferred size after resolvedDialogSize recompute. */
export function shouldSyncDialogSizeFromResolved(
  next: readonly [number, number | null],
  prev: readonly [number, number | null] | undefined,
): boolean {
  if (!prev) {
    return true
  }
  return next[0] !== prev[0] || next[1] !== prev[1]
}
